import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export default function FooterSkeleton() {
  return (
    <div className="portal-main-footer bg-primary">
      <div className="container position--relative">
        <div className="container">
          <div className="pt-2 pb-2 row">
            <div className="ps-5 pe-5 col-sm-12 col-lg-3">
              <div className="sedi container">
                <div className="p-0 row">
                  <div className="p-0 col">
                    <Skeleton width={120} height={20} />
                  </div>
                  <div className="p-0 col-1">
                    <Skeleton width={10} height={20} />
                  </div>
                  <div className="p-0 col">
                    <Skeleton width={120} height={20} />
                  </div>
                </div>
              </div>
              <div className="socials container">
                <div className="ps-2 pe-2 row" style={{ marginTop: 10 }}>
                  {[...Array(5)].map((_, i) => (
                    <div key={i} className="p-0 col">
                      <Skeleton circle={true} height={30} width={30} />
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Prima colonna link */}
            <div className="list-unstyled ps-4 pb-3 col-sm-12 col-lg-3">
              {[...Array(8)].map((_, i) => (
                <div key={i} className="row" style={{ marginBottom: 8 }}>
                  <Skeleton width={180} height={18} />
                </div>
              ))}
            </div>

            {/* Seconda colonna link */}
            <div className="list-unstyled ps-4 pb-3 col-sm-12 col-lg-3">
              {[...Array(7)].map((_, i) => (
                <div key={i} className="row" style={{ marginBottom: 8 }}>
                  <Skeleton width={180} height={18} />
                </div>
              ))}
            </div>

            {/* Terza colonna link */}
            <div className="list-unstyled ps-4 pb-3 col-sm-12 col-lg-3">
              {[...Array(8)].map((_, i) => (
                <div key={i} className="row" style={{ marginBottom: 8 }}>
                  <Skeleton width={180} height={18} />
                </div>
              ))}
            </div>
          </div>

          <div className="ps-3 pe-3 row">
            <div className="col text-center">
              <Skeleton width={400} height={20} />
              <div style={{ marginTop: 10 }}>
                <Skeleton width={300} height={18} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
